import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import api from '../services/api';

const VendorMaster = () => {
  const { selectedFirmId } = useContext(AuthContext);
  const [vendors, setVendors] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Form
  const [editingId, setEditingId] = useState(null);
  const [Name, setName] = useState('');
  const [Address, setAddress] = useState('');
  const [MobileNo, setMobileNo] = useState('');
  const [disc, setDisc] = useState('3');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchVendors();
  }, [selectedFirmId]);

  const fetchVendors = async () => {
    setLoading(true);
    try {
      const res = await api.get('/masters/vendors');
      setVendors(res.data);
    } catch (err) {
      setError('Failed to load vendors');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const payload = {
      Name,
      Address,
      MobileNo,
      disc: Number(disc) || 0,
      FirmId: selectedFirmId
    };

    try {
      if (editingId) {
        await api.put(`/masters/vendors/${editingId}`, payload);
        setSuccess('Vendor updated successfully');
      } else {
        await api.post('/masters/vendors', payload);
        setSuccess('Vendor added successfully');
      }
      resetForm();
      fetchVendors();
    } catch (err) {
      setError('Failed to save vendor');
    }
  };

  const handleEdit = (v) => {
    setEditingId(v.Id);
    setName(v.Name || '');
    setAddress(v.Address || '');
    setMobileNo(v.MobileNo || '');
    setDisc(v.disc || '3');
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete supplier record?')) return;
    try {
      await api.delete(`/masters/vendors/${id}`);
      setSuccess('Vendor deleted');
      fetchVendors();
    } catch (err) {
      setError('Failed to delete vendor');
    }
  };

  const resetForm = () => {
    setEditingId(null);
    setName('');
    setAddress('');
    setMobileNo('');
    setDisc('3');
  };

  const filtered = vendors.filter((v) =>
    (v.Name || '').toLowerCase().includes(search.toLowerCase()) ||
    (v.Address || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
        <div>
          <h3 className="fw-bold mb-1 text-primary">
            <i className="bi bi-truck me-2"></i>Supplier / Vendor Master (विक्रेता)
          </h3>
          <p className="text-muted mb-0">Manage diesel, ice, food, wireless & repair vendors</p>
        </div>
      </div>

      {error && <div className="alert alert-danger py-2">{error}</div>}
      {success && <div className="alert alert-success py-2">{success}</div>}

      <div className="row g-4">
        {/* FORM */}
        <div className="col-12 col-md-4">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-primary text-white fw-bold">
              {editingId ? 'Edit Supplier Details' : 'Add New Supplier'}
            </div>
            <div className="card-body">
              <form onSubmit={handleSave}>
                <div className="mb-3">
                  <label className="form-label fw-semibold">Supplier Name (विक्रेता नांव)</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. SAKHAR SOCIETY / PETROL PUMP"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Address / Location</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. ALIBAG"
                    value={Address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Mobile Number</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Mobile Number"
                    value={MobileNo}
                    onChange={(e) => setMobileNo(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Discount %</label>
                  <input
                    type="number"
                    step="0.1"
                    className="form-control"
                    value={disc}
                    onChange={(e) => setDisc(e.target.value)}
                  />
                </div>

                <div className="d-flex gap-2">
                  <button type="submit" className="btn btn-primary w-100 fw-bold">
                    <i className="bi bi-check-circle me-1"></i> {editingId ? 'Update' : 'Save'}
                  </button>
                  {editingId && (
                    <button type="button" className="btn btn-outline-secondary" onClick={resetForm}>
                      Cancel
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* LIST */}
        <div className="col-12 col-md-8">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
              <h5 className="fw-bold mb-0 text-dark">
                Supplier Directory ({filtered.length})
              </h5>
              <div className="w-50">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search supplier..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
            <div className="table-responsive" style={{ maxHeight: '600px' }}>
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light sticky-top">
                  <tr>
                    <th>#</th>
                    <th>Supplier Name</th>
                    <th>Address</th>
                    <th>Mobile No</th>
                    <th>Disc %</th>
                    <th className="text-end">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="6" className="text-center py-4 text-muted">
                        <span className="spinner-border spinner-border-sm me-2"></span> Loading supplier directory...
                      </td>
                    </tr>
                  ) : filtered.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center py-4 text-muted">
                        No suppliers found.
                      </td>
                    </tr>
                  ) : (
                    filtered.map((v, idx) => (
                      <tr key={v.Id}>
                        <td>{idx + 1}</td>
                        <td className="fw-semibold text-primary">{v.Name}</td>
                        <td>{v.Address || '-'}</td>
                        <td>{v.MobileNo || '-'}</td>
                        <td>{v.disc}%</td>
                        <td className="text-end">
                          <button
                            className="btn btn-outline-primary btn-sm me-1"
                            onClick={() => handleEdit(v)}
                          >
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => handleDelete(v.Id)}
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorMaster;
